import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestContratos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'contratos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteContrato({ payload }) {
  try {
    const { idcontrato, params } = payload;

    yield call(api.delete, `contratos/${idcontrato}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { contrato, params } = payload;

    yield call(api.post, 'contratos', contrato);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/contratos');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { idcontrato } = payload;

    const { data } = yield call(api.get, `contratos/${idcontrato}`);

    data.datainicialcontrato = moment(
      data.datainicialcontrato,
      'DD/MM/YYYY HH:mm:ss'
    ).format('YYYY-MM-DD');
    data.datafinalcontrato = moment(
      data.datafinalcontrato,
      'DD/MM/YYYY HH:mm:ss'
    ).format('YYYY-MM-DD');
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { contrato, params } = payload;

    contrato.datainicialcontrato = moment(contrato.datainicialcontrato)
      .set({ hour: 0, minutes: 0, seconds: 0 })
      .format('DD/MM/YYYY HH:mm:ss');
    contrato.datafinalcontrato = moment(contrato.datafinalcontrato)
      .set({ hour: 23, minutes: 59, seconds: 59 })
      .format('DD/MM/YYYY HH:mm:ss');

    yield call(api.put, 'contratos', contrato);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/contratos');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'contratos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@contrato/CONTRATOS_IN_REQUEST', requestContratos),
  takeLatest('@contrato/DELETE_CONTRATO', deleteContrato),
  takeLatest('@contrato/SUCCESS_REMOVE', requestContratos),
  takeLatest('@contrato/STORE_CONTRATO', store),
  takeLatest('@contrato/FIND_CONTRATO', find),
  takeLatest('@contrato/UPDATE_CONTRATO', update),
  takeLatest('@contrato/RECORD_FILTERING', applyedFilters),
]);
